import meshstats from '../../api/meshstats'

const state = {
    selectedPrefectureId: 26,
    leftData: [],
    rightData: [],
    data1: [],
    data2: [],
    data3: [],
    data4: [],
    data5: [],
    data6: [],
    data7: [],
    data8: [],
    data9: [],
    data10: [],
    data11: [],
    data12: [],
    data13: [],
    data14: [],
    data15: [],
    data16: [],
    data17: [],
    data18: [],
    data19: [],
    data20: [],
    data21: [],
    data22: [],
    data23: [],
    data24: [],
    data25: [],
    data26: [],
    data27: [],
    data28: [],
    data29: [],
    data30: [],
    data31: [],
    data32: [],
    data33: [],
    data34: [],
    data35: [],
    data36: [],
    data37: [],
    data38: [],
    data39: [],
    data40: [],
    data41: [],
    data42: [],
    data43: [],
    data44: [],
    data45: [],
    data46: [],
    data47: [],
    /* prefectures
     * シミュレーション結果データを都道府県毎にを格納するエリア
     * 内部には日付（文字列）をキーにした感染者数、感染率を格納する
     * [ { id: 0, simulationData: [{date: '1970-01-01', infectionRate: 0, numberOfInfected: 0}] } ]
     */
    prefectures: [
        {
            id: 1,
            name: "北海道",
            latitude: 43.063968,
            longitude: 141.347899,
            simulationData: []
        },
        {
            id: 2,
            name: "青森県",
            latitude: 40.824623,
            longitude: 140.740593,
            simulationData: []
        },
        {
            id: 3,
            name: "岩手県",
            latitude: 39.703531,
            longitude: 141.152667,
            simulationData: []
        },
        {
            id: 4,
            name: "宮城県",
            latitude: 38.268839,
            longitude: 140.872103,
            simulationData: []
        },
        {
            id: 5,
            name: "秋田県",
            latitude: 39.7186,
            longitude: 140.102334,
            simulationData: []
        },
        {
            id: 6,
            name: "山形県",
            latitude: 38.240437,
            longitude: 140.363634,
            simulationData: []
        },
        {
            id: 7,
            name: "福島県",
            latitude: 37.750299,
            longitude: 140.467521,
            simulationData: []
        },
        {
            id: 8,
            name: "茨城県",
            latitude: 36.341813,
            longitude: 140.446793,
            simulationData: []
        },
        {
            id: 9,
            name: "栃木県",
            latitude: 36.565725,
            longitude: 139.883565,
            simulationData: []
        },
        {
            id: 10,
            name: "群馬県",
            latitude: 36.391208,
            longitude: 139.060156,
            simulationData: []
        },
        {
            id: 11,
            name: "埼玉県",
            latitude: 35.857428,
            longitude: 139.648933,
            simulationData: []
        },
        {
            id: 12,
            name: "千葉県",
            latitude: 35.605058,
            longitude: 140.123308,
            simulationData: []
        },
        {
            id: 13,
            name: "東京都",
            latitude: 35.689521,
            longitude: 139.691704,
            simulationData: []
        },
        {
            id: 14,
            name: "神奈川県",
            latitude: 35.447753,
            longitude: 139.642514,
            simulationData: []
        },
        {
            id: 15,
            name: "新潟県",
            latitude: 37.902418,
            longitude: 139.023221,
            simulationData: []
        },
        {
            id: 16,
            name: "富山県",
            latitude: 36.69529,
            longitude: 137.211338,
            simulationData: []
        },
        {
            id: 17,
            name: "石川県",
            latitude: 36.594682,
            longitude: 136.625573,
            simulationData: []
        },
        {
            id: 18,
            name: "福井県",
            latitude: 36.065219,
            longitude: 136.221642,
            simulationData: []
        },
        {
            id: 19,
            name: "山梨県",
            latitude: 35.664158,
            longitude: 138.568449,
            simulationData: []
        },
        {
            id: 20,
            name: "長野県",
            latitude: 36.651289,
            longitude: 138.181224,
            simulationData: []
        },
        {
            id: 21,
            name: "岐阜県",
            latitude: 35.391227,
            longitude: 136.722291,
            simulationData: []
        },
        {
            id: 22,
            name: "静岡県",
            latitude: 34.976978,
            longitude: 138.383054,
            simulationData: []
        },
        {
            id: 23,
            name: "愛知県",
            latitude: 35.180188,
            longitude: 136.906565,
            simulationData: []
        },
        {
            id: 24,
            name: "三重県",
            latitude: 34.730283,
            longitude: 136.508591,
            simulationData: []
        },
        {
            id: 25,
            name: "滋賀県",
            latitude: 35.004531,
            longitude: 135.86859,
            simulationData: []
        },
        {
            id: 26,
            name: "京都府",
            latitude: 35.021004,
            longitude: 135.755608, //[35.012500, 135.768750]
            simulationData: []
        },
        {
            id: 27,
            name: "大阪府",
            latitude: 34.686316,
            longitude: 135.519711,
            simulationData: []
        },
        {
            id: 28,
            name: "兵庫県",
            latitude: 34.691279,
            longitude: 135.183025,
            simulationData: []
        },
        {
            id: 29,
            name: "奈良県",
            latitude: 34.685333,
            longitude: 135.832744,
            simulationData: []
        },
        {
            id: 30,
            name: "和歌山県",
            latitude: 34.226034,
            longitude: 135.167506,
            simulationData: []
        },
        {
            id: 31,
            name: "鳥取県",
            latitude: 35.503869,
            longitude: 134.237672,
            simulationData: []
        },
        {
            id: 32,
            name: "島根県",
            latitude: 35.472297,
            longitude: 133.050499,
            simulationData: []
        },
        {
            id: 33,
            name: "岡山県",
            latitude: 34.661772,
            longitude: 133.934675,
            simulationData: []
        },
        {
            id: 34,
            name: "広島県",
            latitude: 34.39656,
            longitude: 132.459622,
            simulationData: []
        },
        {
            id: 35,
            name: "山口県",
            latitude: 34.186121,
            longitude: 131.4705,
            simulationData: []
        },
        {
            id: 36,
            name: "徳島県",
            latitude: 34.06577,
            longitude: 134.559303,
            simulationData: []
        },
        {
            id: 37,
            name: "香川県",
            latitude: 34.340149,
            longitude: 134.043444,
            simulationData: []
        },
        {
            id: 38,
            name: "愛媛県",
            latitude: 33.84166,
            longitude: 132.765362,
            simulationData: []
        },
        {
            id: 39,
            name: "高知県",
            latitude: 33.559705,
            longitude: 133.53108,
            simulationData: []
        },
        {
            id: 40,
            name: "福岡県",
            latitude: 33.606785,
            longitude: 130.418314,
            simulationData: []
        },
        {
            id: 41,
            name: "佐賀県",
            latitude: 33.249367,
            longitude: 130.298822,
            simulationData: []
        },
        {
            id: 42,
            name: "長崎県",
            latitude: 32.744839,
            longitude: 129.873756,
            simulationData: []
        },
        {
            id: 43,
            name: "熊本県",
            latitude: 32.789828,
            longitude: 130.741667,
            simulationData: []
        },
        {
            id: 44,
            name: "大分県",
            latitude: 33.238194,
            longitude: 131.612591,
            simulationData: []
        },
        {
            id: 45,
            name: "宮崎県",
            latitude: 31.91109,
            longitude: 131.423855,
            simulationData: []
        },
        {
            id: 46,
            name: "鹿児島県",
            latitude: 31.560148,
            longitude: 130.557981,
            simulationData: []
        },
        {
            id: 47,
            name: "沖縄県",
            latitude: 26.212401,
            longitude: 127.680932,
            simulationData: []
        }
    ]
}
const getters = {
    getPrefectureById: (state) => (id) => {
        let data = state.prefectures.find(prefecture => prefecture.id === id)
        if (data === undefined) {
            return []
        }
        return data
    },
    selectedPrefectureId: (state) => {
        return state.selectedPrefectureId
    },
    prefectures: (state) => {
        return state.prefectures
    },
    currentPrefectureData: (state) => {
        return state.currentData
    },
    getPrefectureIndex: (state) => (id) => {
        return state.prefectures.findIndex((prefecture) => prefecture.id === id)
    },
    data1: (state) => {
        return state.data1
    },
    data2: (state) => {
        return state.data2
    },
    data3: (state) => {
        return state.data3
    },
    data4: (state) => {
        return state.data4
    },
    data5: (state) => {
        return state.data5
    },
    data6: (state) => {
        return state.data6
    },
    data7: (state) => {
        return state.data7
    },
    data8: (state) => {
        return state.data8
    },
    data9: (state) => {
        return state.data9
    },
    data10: (state) => {
        return state.data10
    },
    data11: (state) => {
        return state.data11
    },
    data12: (state) => {
        return state.data12
    },
    data13: (state) => {
        return state.data13
    },
    data14: (state) => {
        return state.data14
    },
    data15: (state) => {
        return state.data15
    },
    data16: (state) => {
        return state.data16
    },
    data17: (state) => {
        return state.data17
    },
    data18: (state) => {
        return state.data18
    },
    data19: (state) => {
        return state.data19
    },
    data20: (state) => {
        return state.data20
    },
    data21: (state) => {
        return state.data21
    },
    data22: (state) => {
        return state.data22
    },
    data23: (state) => {
        return state.data23
    },
    data24: (state) => {
        return state.data24
    },
    data25: (state) => {
        return state.data25
    },
    data26: (state) => {
        return state.data26
    },
    data27: (state) => {
        return state.data27
    },
    data28: (state) => {
        return state.data28
    },
    data29: (state) => {
        return state.data29
    },
    data30: (state) => {
        return state.data30
    },
    data31: (state) => {
        return state.data31
    },
    data32: (state) => {
        return state.data32
    },
    data33: (state) => {
        return state.data33
    },
    data34: (state) => {
        return state.data34
    },
    data35: (state) => {
        return state.data35
    },
    data36: (state) => {
        return state.data36
    },
    data37: (state) => {
        return state.data37
    },
    data38: (state) => {
        return state.data38
    },
    data39: (state) => {
        return state.data39
    },
    data40: (state) => {
        return state.data40
    },
    data41: (state) => {
        return state.data41
    },
    data42: (state) => {
        return state.data42
    },
    data43: (state) => {
        return state.data43
    },
    data44: (state) => {
        return state.data44
    },
    data45: (state) => {
        return state.data45
    },
    data46: (state) => {
        return state.data46
    },
    data47: (state) => {
        return state.data47
    },
    leftData: (state) => {
        return state.leftData
    },
    rightData: (state) => {
        return state.rightData
    },
}
const mutations = {
    setLocation(state, prefectureId) {
        state.prefectureId = prefectureId
    },
    setData(state, prefecture) {
        state.currentData = prefecture.data
        switch (prefecture.slot) {
            case 1:
                state.data1 = prefecture.data
                break
            case 2:
                state.data2 = prefecture.data
                break
            case 3:
                state.data3 = prefecture.data
                break
            case 4:
                state.data4 = prefecture.data
                break
            case 5:
                state.data5 = prefecture.data
                break
            case 6:
                state.data6 = prefecture.data
                break
            case 7:
                state.data7 = prefecture.data
                break
            case 8:
                state.data8 = prefecture.data
                break
            case 9:
                state.data9 = prefecture.data
                break
            case 10:
                state.data10 = prefecture.data
                break
            case 11:
                state.data11 = prefecture.data
                break
            case 12:
                state.data12 = prefecture.data
                break
            case 13:
                state.data13 = prefecture.data
                break
            case 14:
                state.data14 = prefecture.data
                break
            case 15:
                state.data15 = prefecture.data
                break
            case 16:
                state.data16 = prefecture.data
                break
            case 17:
                state.data17 = prefecture.data
                break
            case 18:
                state.data18 = prefecture.data
                break
            case 19:
                state.data19 = prefecture.data
                break
            case 20:
                state.data20 = prefecture.data
                break
            case 21:
                state.data21 = prefecture.data
                break
            case 22:
                state.data22 = prefecture.data
                break
            case 23:
                state.data23 = prefecture.data
                break
            case 24:
                state.data24 = prefecture.data
                break
            case 25:
                state.data25 = prefecture.data
                break
            case 26:
                state.data26 = prefecture.data
                break
            case 27:
                state.data27 = prefecture.data
                break
            case 28:
                state.data28 = prefecture.data
                break
            case 29:
                state.data29 = prefecture.data
                break
            case 30:
                state.data30 = prefecture.data
                break
            case 31:
                state.data31 = prefecture.data
                break
            case 32:
                state.data32 = prefecture.data
                break
            case 33:
                state.data33 = prefecture.data
                break
            case 34:
                state.data34 = prefecture.data
                break
            case 35:
                state.data35 = prefecture.data
                break
            case 36:
                state.data36 = prefecture.data
                break
            case 37:
                state.data37 = prefecture.data
                break
            case 38:
                state.data38 = prefecture.data
                break
            case 39:
                state.data39 = prefecture.data
                break
            case 40:
                state.data40 = prefecture.data
                break
            case 41:
                state.data41 = prefecture.data
                break
            case 42:
                state.data42 = prefecture.data
                break
            case 43:
                state.data43 = prefecture.data
                break
            case 44:
                state.data44 = prefecture.data
                break
            case 45:
                state.data45 = prefecture.data
                break
            case 46:
                state.data46 = prefecture.data
                break
            case 47:
                state.data47 = prefecture.data
                break
            case 100:
                state.leftData = prefecture.data
                break
            case 101:
                state.rightData = prefecture.data
                break
            default:
        }
        const findFunc = (element) => element.id == prefecture.id
        let index = state.prefectures.findIndex(findFunc)
        if (index < 0) return
        var prefectures = state.prefectures
        prefectures[index].simulationData = prefecture.data
        state.prefectures = prefectures
    }
}
const actions = {
    selectPrefecture: ({ dispatch, commit }, params) => {
        commit('setLocation', params.prefectureId)
        dispatch("fetchPrefectureData", params)
    },
    setPrefectureData: ({ commit }, prefecture) => {
        commit('setData', prefecture)
    },
    fetchPrefectureData: ({ commit }, params) => {
        meshstats.fetchCovid19Data(params, (caseRecords, infectionRecords, observationRecords) => {
            var now = new Date();
            var thirtyDaysFuture = now.getTime() + (1000*60*60*24*30);
            const filter = function(record) {
                var date = new Date(record.date);
                return date.getTime() <= thirtyDaysFuture;
            }
            var data = caseRecords.filter(filter).map(record => {
                return {
                    date: record.date,
                    numberOfInfected: record.value,
                    infectionRate: -1,
                    numberOfObservation: -1
                }
            })
            infectionRecords.filter(filter).forEach(record => {
                const find = function(element) {
                    var recordDate = new Date(record.date);
                    var elementDate = new Date(element.date);
                    return elementDate.getTime() == recordDate.getTime();
                }
                let index = data.findIndex(find)
                if (index >= 0) {
                    data[index].infectionRate = record.value
                } else {
                    data.push({
                        date: record.date,
                        numberOfInfected: -1,
                        infectionRate: record.value,
                        numberOfObservation: -1
                    })
                }
            })
            observationRecords.filter(filter).forEach(record => {
                const find = function(element) {
                    var recordDate = new Date(record.date);
                    var elementDate = new Date(element.date);
                    return elementDate.getTime() == recordDate.getTime();
                }
                //const find = (element) => element.date == new Date(record.date)
                let index = data.findIndex(find)
                if (index >= 0) {
                    data[index].numberOfObservation = record.value
                }
                // 実測値のデータ期間が異なるので、シミュレーション値と同じ年月日が見つからない場合はスキップ
                /*
                else {
                    data.push({
                        date: record.date,
                        numberOfInfected: 0,
                        infectionRate: 0,
                        numberOfObservation: record.value
                    })
                }
                */
            })
            var sortedData = data.sort((a, b) => {
                var aDate = new Date(a.date);
                var bDate = new Date(b.date);
                return aDate.getTime() - bDate.getTime()
            })
            commit("setData", { slot: params.slot, id: params.prefectureId, data: sortedData })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}